import { combineReducers } from "redux";
import { authReducer, forgotReducer, storePermissionReducer, surveyQuizReducer } from "./authentication/reducers";
import ChangeLayoutMode from "./themeLayout/reducers";
import { productDiscoveryTokenReducers, splProductTargetReducers, storeContentVideoDetailsReducers, storeContentVideoDownloadReducers, storeDashboardDataReducers } from "./dashboard/reducers";
import {
  aboutInfoDataReducers,
  aboutInfoPPTListDataReducers,
  aboutInfoPPTDetailsDataReducers,
  submitAboutPPTInfoDataReducers,
  aboutCustomerInfoDataReducers,
  submitaAboutFBODataReducers,
  getExchangeDataReducers,
  submitAboutMissingPPTInfoDataReducers,
  AboutHistoryDataReducers,
  AboutViewDetailsReducer,
  AboutFBOHistoryDataReducers,
  AboutFBOViewDetailsReducer,
  postStartTokenDataReducers,
  postExchnagePricenDataReducers,
  aboutItemSearchDataReducers,
} from "./about/reducers";
import {
  outdoorInfoDataReducers,
  outdoorInfoPPTListDataReducers,
  outdoorInfoPPTDetailsDataReducers,
  submitOutdoorPPTInfoDataReducers,
  outdoorCustomerInfoDataReducers,
  getExchangeDataReducers as outdoorExchangeDataReducers,
  submitOutdoorMissingPPTInfoDataReducers,
  OutdoorHistoryDataReducers,
  OutdoorViewDetailsReducer,
  postStartTokenDataReducers as outdoorStartTokenDataReducers,
  postExchnagePricenDataReducers as outdoorExchnagePricenDataReducers,
} from "./outdoor/reducers";
import {
  qrDashboardDataReducers,
  qrPaymentInfoDataReducers,
} from "./qr/reducers";
import {
  miningDashboardDataReducers,
  miningCategoryListReducers,
  miningReasonListReducers,
  miningLeadsReducers,
  submitMiningReducers,
  MiningPushLeadsReducers,
} from "./mining/reducers";
import { getStoreRankingDataReducers } from "./ranking/reducers";
import {
  apexTradeModelListReducer,
  commonFileUploadReducer,
  exchangeModelDetailReducer,
  getBrandReducers,
  getEmployeeDetailReducers,
  getEmployeeListReducers,
  getModelReducers,
  getPaymentReducers,
  productTypeReducers,
  tradeModelListReducer,
} from "./common/reducers";
import {
  checkAffordabilityReducer,
  exchangeDashboardReducers,
  exchangeProcessingDataReducer,
  exchangeHistoryReducers,
  inhouseReferenceHistoryReducers,
  exchangeViewReducers,
  fileUploadReducer,
  submitExchangePickupDataReducer,
  inhouseSubmitExchangePickupDataReducer,
  submitExchangeDataReducer,
  vendorListDataReducer,
  getExchangeNewIMEIListDataReducer,
  getSchemeListDataReducer,
  paymentMethodReducer,
  postExchnageInhouseDataReducers,
} from "./exchange/reducers";
import { couponDetailsReducer, couponHistoryReducer, generateCouponReducer, getRefDetailsReducer, offerProductListReducer } from "./15off/reducers";
import {
  financeCompanyListReducer,
  financeGenerateOtpReducer,
  financeHistoryReducer,
  financeUpdateProductProofDetailsReducer,
  financeUpdateProofDetailsReducer,
  financeViewDetailsReducer,
  financeVerifyOtpReducer,
} from "./finance/reducers";
import {
  autoBillingHistoryReducer,
  autoBillingManualReducer,
  autoBillingPartnerListReducer,
  autoBillingPaymentModeReducer,
  autoBillingReferenceReducer,
  autoBillingSubmitReducer,
} from "./autoBilling/reducers";
import {
  managerAlternativeMethodReducer,
  managerDashboardReducer,
  managerDiscountCalculateReducer,
  managerGenerateOtpReducer,
  managerHistoryReducer,
  managerModelDiscountReducer,
  managerPriceListReducer,
  managerSendRequestReducer,
  managerVerifyOtpReducer,
  managerViewReducer,
} from "./managerDiscount/reducers";
import { splDashboardReducer } from "./spl/reducers";
import { storeMarketingExpenseReducer, storeMarketingImagesGalleryReducer } from "./marketing/reducers";
import {
  gateMeetingVideoChunkReducers,
  gateMeetingVideoCompleteReducers,
  gateMeetingVideoStartReducers,
  gateMeetingSubmitReducers,
  splStoreSummaryReducers,
} from "./meeting/reducers";

const rootReducers = combineReducers({
  // Base Reducers
  auth: authReducer,
  forgot: forgotReducer,
  ChangeLayoutMode,
  storeDashboardData: storeDashboardDataReducers,
  splProductTargetData: splProductTargetReducers,
  productDiscoveryToken: productDiscoveryTokenReducers,
  storeContentVideoDetailsData: storeContentVideoDetailsReducers,
  storeContentVideoDownloadData: storeContentVideoDownloadReducers,
  splDashboardData: splDashboardReducer,
  storeMarketingExpenseData: storeMarketingExpenseReducer,
  storeMarketingImagesGalleryData: storeMarketingImagesGalleryReducer,
  storePermission: storePermissionReducer,
  surveyQuiz: surveyQuizReducer,

  // About Reducers
  aboutInfoData: aboutInfoDataReducers,
  aboutInfoPPTListData: aboutInfoPPTListDataReducers,
  aboutInfoPPTDetailsData: aboutInfoPPTDetailsDataReducers,
  aboutCustomerInfoData: aboutCustomerInfoDataReducers,
  submitAboutPPTInfoData: submitAboutPPTInfoDataReducers,
  submitaAboutFBOData: submitaAboutFBODataReducers,
  submitAboutMissingPPTInfoData:submitAboutMissingPPTInfoDataReducers,
  getExchangeData:getExchangeDataReducers,
  aboutItemSearchData: aboutItemSearchDataReducers,
  AboutHistoryData:AboutHistoryDataReducers,
  AboutViewDetails:AboutViewDetailsReducer,
  AboutFBOHistoryData:AboutFBOHistoryDataReducers,
  AboutFBOViewDetails:AboutFBOViewDetailsReducer,
  postStartTokenData:postStartTokenDataReducers,
  postExchnagePricenData:postExchnagePricenDataReducers,

  // Outdoor Reducers
  outdoorInfoData: outdoorInfoDataReducers,
  outdoorInfoPPTListData: outdoorInfoPPTListDataReducers,
  outdoorInfoPPTDetailsData: outdoorInfoPPTDetailsDataReducers,
  outdoorCustomerInfoData: outdoorCustomerInfoDataReducers,
  submitOutdoorPPTInfoData: submitOutdoorPPTInfoDataReducers,
  submitOutdoorMissingPPTInfoData: submitOutdoorMissingPPTInfoDataReducers,
  getOutdoorExchangeData: outdoorExchangeDataReducers,
  OutdoorHistoryData: OutdoorHistoryDataReducers,
  OutdoorViewDetails: OutdoorViewDetailsReducer,
  outdoorStartTokenData: outdoorStartTokenDataReducers,
  outdoorExchnagePricenData: outdoorExchnagePricenDataReducers,

  // QR Reducers
  qrDashboardData: qrDashboardDataReducers,
  qrPaymentInfoData: qrPaymentInfoDataReducers,

  // Mining Reducers
  miningDashboardData: miningDashboardDataReducers,
  miningCategoryList: miningCategoryListReducers,
  miningReasonList: miningReasonListReducers,
  miningLeads: miningLeadsReducers,
  submitMining: submitMiningReducers,

  // Push Leads
  MiningPushLeads: MiningPushLeadsReducers,

  // Ranking Reducers
  StoreRankingData: getStoreRankingDataReducers,

  // Finance Reducers
  financeCompanyListData: financeCompanyListReducer,
  financeGenerateOtpData: financeGenerateOtpReducer,
  financeVerifyOtpData: financeVerifyOtpReducer,
  financeHistoryData: financeHistoryReducer,
  financeViewDetailsData: financeViewDetailsReducer,
  financeUpdateProofDetailsData: financeUpdateProofDetailsReducer,
  financeUpdateProductProofDetailsData: financeUpdateProductProofDetailsReducer,

  // Auto Billing Reducers
  autoBillingPartnerListData: autoBillingPartnerListReducer,
  autoBillingReferenceData: autoBillingReferenceReducer,
  autoBillingPaymentModeData: autoBillingPaymentModeReducer,
  autoBillingSubmitData: autoBillingSubmitReducer,
  autoBillingManualData: autoBillingManualReducer,
  autoBillingHistoryData: autoBillingHistoryReducer,

  // Manager Discount Reducers
  managerDashboardData: managerDashboardReducer,
  managerPriceListData: managerPriceListReducer,
  managerModelDiscountData: managerModelDiscountReducer,
  managerDiscountCalculateData: managerDiscountCalculateReducer,
  managerGenerateOtpData: managerGenerateOtpReducer,
  managerVerifyOtpData: managerVerifyOtpReducer,
  managerSendRequestData: managerSendRequestReducer,
  managerHistoryData: managerHistoryReducer,
  managerViewData: managerViewReducer,
  managerAlternativeMethodData: managerAlternativeMethodReducer,

  // Meeting Reducers
  splStoreSummaryData: splStoreSummaryReducers,
  gateMeetingVideoStartData: gateMeetingVideoStartReducers,
  gateMeetingVideoChunkData: gateMeetingVideoChunkReducers,
  gateMeetingVideoCompleteData: gateMeetingVideoCompleteReducers,
  gateMeetingSubmitData: gateMeetingSubmitReducers,

  // Common Reducers
  productType: productTypeReducers,
  getModel: getModelReducers,
  getBrand: getBrandReducers,
  getPayment: getPaymentReducers,
  getEmployeeDetail: getEmployeeDetailReducers,
  getEmployeeList: getEmployeeListReducers,
  exchangeModelDetail: exchangeModelDetailReducer,
  apexTradeModelListData: apexTradeModelListReducer,
  tradeModelListData: tradeModelListReducer,
  commonFileUpload: commonFileUploadReducer,

  // Exchange Reducers
  exchangeDashboard: exchangeDashboardReducers,
  vendorListData: vendorListDataReducer,
  exchangeProcessingData: exchangeProcessingDataReducer,
  checkAffordability: checkAffordabilityReducer,
  fileUpload: fileUploadReducer,
  exchangeHistory: exchangeHistoryReducers,
  inhouseReferenceHistory: inhouseReferenceHistoryReducers,
  exchangeView: exchangeViewReducers,
  exchangePickupData: submitExchangePickupDataReducer,
  inhouseSubmitExchangePickupData: inhouseSubmitExchangePickupDataReducer,
  getExchangeNewIMEIListData:getExchangeNewIMEIListDataReducer,
  submitExchangeData:submitExchangeDataReducer,
  getSchemeListData:getSchemeListDataReducer,
  paymentMethodData:paymentMethodReducer,
  postExchnageInhouseData:postExchnageInhouseDataReducers,

  //15% Off Reducers
  generateCouponData:generateCouponReducer,
  getRefDetailsData:getRefDetailsReducer,
  offerProductListData:offerProductListReducer,
  couponHistoryData:couponHistoryReducer,
  couponDetailsData:couponDetailsReducer,
});

export default rootReducers;
